import { makeFullName } from '@harvestiq/utils';
import { Entity } from './entity';
import { isEntityFirstNameLastNameAllowedAndAvailable } from './is-entity-firstName-lastName-allowed';

type EntityValues = Pick<
  Entity,
  'businessName' | 'firstName' | 'lastName' | 'type' | 'taxIdType'
>;

export function getEntityName(entity: EntityValues | null | undefined) {
  if (!entity) {
    return '';
  }

  const isEntityNameAllowedAndAvailable =
    isEntityFirstNameLastNameAllowedAndAvailable({
      taxIdType: entity.taxIdType,
      entityTypeCode: entity.type,
      firstName: entity.firstName,
      lastName: entity.lastName,
    });

  if (isEntityNameAllowedAndAvailable) {
    return makeFullName(entity.firstName, entity.lastName);
  }

  return entity.businessName ?? '';
}
